import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4 py-20">
      <div className="w-20 h-20 bg-primary-50 rounded-full flex items-center justify-center mb-6">
        <i className="ri-tv-line text-3xl text-primary-400"></i>
      </div>
      <h1 className="text-4xl md:text-5xl font-bold text-primary-900 mb-2">404</h1>
      <h2 className="text-xl font-semibold text-foreground-700 mb-2">Page Not Found</h2>
      <p className="text-foreground-500 max-w-md mb-8">
        The page you are looking for does not exist or may have been moved. Please check the URL or navigate back to the homepage.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Link to="/" className="ltv-btn-primary inline-flex items-center gap-2 justify-center">
          <i className="ri-home-line"></i>
          Back to Home
        </Link>
        <Link to="/contact" className="ltv-btn-accent inline-flex items-center gap-2 justify-center">
          <i className="ri-mail-line"></i>
          Contact Us
        </Link>
      </div>
    </div>
  );
}